import React from 'react'
import Header from './Header'
import HomeBody from './HomeBody'

const Home = () => {
  return (
    <>
      <Header/>
      <HomeBody/>
    </>
  )
}

export default Home